
<div class="banner_header">
    <div class="row" style="margin: 0px;">
        <div class="col-md-6">
            <h2>Exam Fees</h2>
        </div>
        <!-- <div class="col-md-6 align-right">
            <button>Log Out</button>
        </div> -->
    </div>

</div>

<!--Content Start-->
<section class="section_box_one">
    <div class="container">
        <h2>CTS CBT Main Exam AITT-2022 Fee Payment link </h2>
        
    </div>
</section>
<!--Content End-->

<div class="container payment_cls" *ngIf="bool_login">
<div class="container" >
    <div class="row d-flex justify-content-center">
        <div class="col-md-4 ">
            <!--FORM1 Start-->
            <div class="card-body">
               
                <div class="alert alert-success" role="alert" *ngIf="bool_success">
                    {{reciveuserstatus}}
                  </div>
            
                <div class="alert alert-danger" role="alert" *ngIf="bool_failure">
                    {{reciveuserstatus}}
                  </div>
  
                <!-- <h2>SINGLE / BULK</h2> -->
                  <form [formGroup]="bdnuForm" (ngSubmit)="onSubmit()">
                      <div class="form-row">
                        
                        <div class="form-group col-12">
                            <label>Roll Number <span class="clr_red"> * </span></label>
                            <input type="text" formControlName="regno" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.regno.errors }" maxlength="50"
                                placeholder="Enter Your Roll Number" (keypress)="omit_spl($event)" />
                            <div *ngIf="submitted && f.regno.errors" class="invalid-feedback">
                                <div *ngIf="f.regno.errors.required">Enter Your Roll Number</div>
                            </div>
                        </div>

                        <div class="form-group col-12">
                            <label>DOB <span class="clr_red"> * </span>
                            <p class="small">   </p></label>
                            <input type="date" formControlName="dob" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.dob.errors }" maxlength="50"
                                placeholder="Enter Your DOB" (keypress)="omit_spl($event)" />
                            <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                                <div *ngIf="f.dob.errors.required">Enter Your DOB</div>
                            </div>
                        </div>                        

                      </div>
                      <hr>
                      <div class="form-row">
                          <div class="form-group col-12">
                              <div class="text-center">
                                  <button class="btn btn-primary mr-1">Submit</button>
                              </div>
                              <div *ngIf="bool_spinner" class="bg-overlay_cls">
                                Please Wait...
                                </div>
                          </div>
                      </div>
                  </form>
              </div>
              </div>
            </div>
        </div>
</div>

<div class="container payment_cls" *ngIf="bool_form">
    <form [formGroup]="payForm" (ngSubmit)="onPaySubmit()">

        
      <div class="form-row">
        <div class="form-group col-4">
            <label>ITI Code <span class="clr_red"> * </span></label>
            <input type="text" formControlName="ITICode" class="form-control" [(ngModel)]="letITICode"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>State Name <span class="clr_red"> * </span></label>
            <input type="text" formControlName="StateName" class="form-control" [(ngModel)]="letStateName"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Distric tName <span class="clr_red"> * </span></label>
            <input type="text" formControlName="DistrictName" class="form-control" [(ngModel)]="letDistrictName"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Roll Number <span class="clr_red"> * </span></label>
            <input type="text" formControlName="RollNumber" class="form-control" [(ngModel)]="letRollNumber"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Trainee Name <span class="clr_red"> * </span></label>
            <input type="text" formControlName="TraineeName" class="form-control" [(ngModel)]="letTraineeName"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Trainee Father Name <span class="clr_red"> * </span></label>
            <input type="text" formControlName="TraineeFatherName" class="form-control" [(ngModel)]="letTraineeFatherName"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>DOB <span class="clr_red"> * </span></label>
            <input type="text" formControlName="DOB" class="form-control" [(ngModel)]="letDOB"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>ITI Name <span class="clr_red"> * </span></label>
            <input type="text" formControlName="ITIName" class="form-control" [(ngModel)]="letITIName"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Email <span class="clr_red"> * </span></label>
            <input type="text" formControlName="email" class="form-control" [(ngModel)]="letemail"
            readonly />    
                 <!-- <button type="button" (click)="fn_update_email()">update</button>    -->
        </div>
        <div class="form-group col-4">
            <label>ITI Address <span class="clr_red"> * </span></label>
            <input type="text" formControlName="ITIaddress" class="form-control" [(ngModel)]="letITIaddress"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Gender <span class="clr_red"> * </span></label>
            <input type="text" formControlName="gender" class="form-control" [(ngModel)]="letgender"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Trade <span class="clr_red"> * </span></label>
            <input type="text" formControlName="Trade" class="form-control" [(ngModel)]="letTrade"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Trade Code <span class="clr_red"> * </span></label>
            <input type="text" formControlName="Tradecode" class="form-control" [(ngModel)]="letTradecode"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Exaim  <span class="clr_red"> * </span></label>
            <input type="text" formControlName="Exam" class="form-control" [(ngModel)]="letExam"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Exaim Id <span class="clr_red"> * </span></label>
            <input type="text" formControlName="Exaimid" class="form-control" [(ngModel)]="letExamid"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Duration <span class="clr_red"> * </span></label>
            <input type="text" formControlName="duration" class="form-control" [(ngModel)]="letduration"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Mobile <span class="clr_red"> * </span></label>
            <input type="text" formControlName="mobile" class="form-control" [(ngModel)]="letmobile"
               readonly />        
        </div>
        <div class="form-group col-4">
            <label>Amount <span class="clr_red"> * </span></label>
            <input type="text" formControlName="amount" class="form-control" [(ngModel)]="letAmount"
               readonly />        
        </div>
                   

      </div>
      <hr>
      <div class="form-row">
          <div class="form-group col-12">
              <div class="text-center">
                  <button class="btn btn-primary mr-1">Pay</button>
              </div>
              <div *ngIf="bool_spinner" class="bg-overlay_cls">
                Please Wait...
                </div>
          </div>
      </div>
      
    </form>
</div>